'use strict';

var scrollAnimate = require('../components/scrollAnimate');

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        let $input = $('*[name=' + attr + ']', parentSelector);

        // Display error for the new password input
        if ($input.closest('.custom-password').find('.input-group')) {
            $input.parent().addClass('is-invalid');
            $input.addClass('is-invalid');
            $input.closest('.custom-password').find('.invalid-feedback').html(fieldErrors[attr]);
        }

        $input
        .addClass('is-invalid')
        .siblings('.invalid-feedback')
        .html(fieldErrors[attr]);
    });
    // Animate to top of form that has errors
    scrollAnimate($(parentSelector));

    let $invalidInputs = $(parentSelector).find('input.is-invalid:visible');

    if ($invalidInputs.length) {
        $invalidInputs[0].focus();
    }
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $(parentSelector).find('.input-group.is-invalid').removeClass('is-invalid');
    $('.error-message').hide();
}

module.exports = {
    loadFormErrors: loadFormErrors,
    clearPreviousErrors: clearPreviousErrors
};
